<template>
    <nav aria-label="breadcrumb">
      <div class="breadcrumb">
        <span v-for="(crumb, index) in breadcrumbs" :key="index" class="breadcrumb-item" :class="{ active: index === breadcrumbs.length - 1 }">
          <a v-if="index !== breadcrumbs.length - 1" :href="crumb.to">{{ crumb.text }}</a>
          <span v-else>{{ crumb.text }}</span>
        </span>
      </div>
    </nav>
  </template>
  
  <script>
  export default {
    props: {
      breadcrumbs: {
        type: Array,
        required: true
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  $--group-option-flex: 0 calc(1 / 5) * 100%!default;
  .breadcrumb {
    // color: #000 !important;
    margin: 20px auto;
    list-style: none;
    border-radius: 4px;
    max-width: 100%;
    
    @media (min-width: 768px) {
      max-width: 80%;
    }
  }
  .breadcrumb-item {
    color: #000 !important;
    a {
      color: #000 !important;
      text-decoration: none;
      &:hover {
        color: #6beae4 !important;
      }
    }
    &::before {
    content: ">";
    padding: 0 6px;
    color: #000;
    }
  }
  </style>
  